import { Button } from '@optools/components/ui/button';
import { Input } from '@optools/components/ui/input';
import { Popover, PopoverContent, PopoverTrigger } from '@optools/components/ui/popover';
import { Tooltip, TooltipContent, TooltipTrigger } from '@optools/components/ui/tooltip';
import { Calendar } from 'lucide-react';
import { useId } from 'react';

import { formatVideoTimestamp } from '../utils/milestones';
import { TrimTimeForm } from './trim-time-form';

export interface TrimTimeInputProps {
  disabled: boolean;
  label: string;
  onClick: () => void;
  onSubmit: (time: number) => void;
  programDateTime: string;
  videoTime: number;
}

export function TrimTimeInput({
  disabled,
  label,
  onClick,
  onSubmit,
  programDateTime,
  videoTime,
}: TrimTimeInputProps) {
  const id = useId();

  return (
    <div className="flex items-end gap-1">
      <div className="flex flex-col gap-1">
        <label className="text-xs" htmlFor={id}>
          {label}
        </label>
        <Input className="w-24" disabled id={id} value={formatVideoTimestamp(videoTime)} />
      </div>

      <Popover>
        <Tooltip>
          <TooltipTrigger asChild>
            <PopoverTrigger asChild>
              <Button disabled={disabled} size="icon" variant="secondary" onClick={onClick}>
                <span className="sr-only">Use Absolute Time</span>
                <Calendar />
              </Button>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent side="bottom" sideOffset={8}>
            Use Absolute Timestamp (UTC)
          </TooltipContent>
        </Tooltip>
        <PopoverContent sideOffset={8}>
          <TrimTimeForm
            programDateTime={programDateTime}
            videoTime={videoTime}
            onSubmit={onSubmit}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
